import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// save a new Rdp --admin
export const saveNewRdps = createAsyncThunk(
  "rdps/saveNewRdps",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/rdps/new`,
        data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      // Check if the login is successful
      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      console.log("error during add rdp ", error);
      const errorMessage =
        error.response?.data?.message || "An error occurred during login.";
      return rejectWithValue(errorMessage);
    }
  }
);

// get all the rdps --admin
export const getAllRdps = createAsyncThunk(
  "rdps/getAllRdps",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/rdps/all`,
        data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      // Check if the login is successful
      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during login.";
      return rejectWithValue(errorMessage);
    }
  }
);

//assign a rdp to a user --admin
export const assignRdpToUser = createAsyncThunk(
  "rdps/assignRdpToUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/rdps/assignuser`,
        data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during login.";
      return rejectWithValue(errorMessage);
    }
  }
);

//assign a user to a rdp --admin
export const assignUsertordp = createAsyncThunk(
  "rdps/assignUsertordp",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/rdps/assign`,
        data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during login.";
      return rejectWithValue(errorMessage);
    }
  }
);

// update a rdps  --admin
export const updateRdps = createAsyncThunk(
  "rdps/updateRdps",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/rdps/admin/${data.id}`,
        data.data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during login.";
      return rejectWithValue(errorMessage);
    }
  }
);

// block a rdp  --admin
export const blockRdp = createAsyncThunk(
  "rdps/blockRdp",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/rdps/admin/${data.id}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during login.";
      return rejectWithValue(errorMessage);
    }
  }
);
